import { render, staticRenderFns } from "./addContactCombo.vue?vue&type=template&id=52d6389e&scoped=true"
import script from "./addContactCombo.vue?vue&type=script&lang=js"
export * from "./addContactCombo.vue?vue&type=script&lang=js"
import style0 from "./addContactCombo.vue?vue&type=style&index=0&id=52d6389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6389e",
  null
  
)

export default component.exports